export const UserRole = { ADMIN: 'ADMIN', USER: 'USER' };
export const USER_ROLES = Object.values(UserRole);
export const UserStatus = { INVITED: 'INVITED', ACTIVE: 'ACTIVE', INACTIVE: 'INACTIVE' };
export const USER_STATUSES = Object.values(UserStatus);
export const EntityStatus = { ACTIVE: 'ACTIVE', ARCHIVED: 'ARCHIVED' };
export const ENTITY_STATUSES = Object.values(EntityStatus);
export const ActivityType = { SHARED: 'SHARED', PERSONAL: 'PERSONAL' };
export const ACTIVITY_TYPES = Object.values(ActivityType);
/**
 * `TIMER` is historical: the start/stop timer is gone, so nothing writes it any more. The value
 * stays because rows created by it still say so, and the day view still labels them honestly.
 */
export const EntrySource = { MANUAL: 'MANUAL', TIMER: 'TIMER', IMPORT: 'IMPORT' };
export const ENTRY_SOURCES = Object.values(EntrySource);
export const AuthTokenPurpose = { INVITE: 'INVITE', PASSWORD_RESET: 'PASSWORD_RESET' };
export const AUTH_TOKEN_PURPOSES = Object.values(AuthTokenPurpose);
export const ReportType = {
    PDF_SUMMARY: 'PDF_SUMMARY',
    XLSX_ENTRIES: 'XLSX_ENTRIES',
    XLSX_DATABASE: 'XLSX_DATABASE',
};
export const REPORT_TYPES = Object.values(ReportType);
export const ReportStatus = {
    QUEUED: 'QUEUED',
    RUNNING: 'RUNNING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    EXPIRED: 'EXPIRED',
};
export const REPORT_STATUSES = Object.values(ReportStatus);
export const HoursFormat = { DECIMAL: 'DECIMAL', HH_MM: 'HH_MM' };
export const HOURS_FORMATS = Object.values(HoursFormat);
/** Machine-readable error codes returned in the `code` field of problem details. */
export const ErrorCode = {
    BAD_REQUEST: 'BAD_REQUEST',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    SESSION_INVALID: 'SESSION_INVALID',
    FORBIDDEN: 'FORBIDDEN',
    ACCOUNT_INACTIVE: 'ACCOUNT_INACTIVE',
    CSRF_HEADER_MISSING: 'CSRF_HEADER_MISSING',
    CSRF_ORIGIN_MISMATCH: 'CSRF_ORIGIN_MISMATCH',
    LAST_ADMIN: 'LAST_ADMIN',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    DUPLICATE_NAME: 'DUPLICATE_NAME',
    HAS_TIME_ENTRIES: 'HAS_TIME_ENTRIES',
    HAS_ACTIVITIES: 'HAS_ACTIVITIES',
    GROUP_NOT_EMPTY: 'GROUP_NOT_EMPTY',
    EMAIL_TAKEN: 'EMAIL_TAKEN',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    REPORT_EXPIRED: 'REPORT_EXPIRED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    DAY_LIMIT_EXCEEDED: 'DAY_LIMIT_EXCEEDED',
    /** The entry's date is in a period an administrator has closed (see `isTimesheetLocked`). */
    TIMESHEET_LOCKED: 'TIMESHEET_LOCKED',
    NOT_SELECTABLE: 'NOT_SELECTABLE',
    ARCHIVED: 'ARCHIVED',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
//# sourceMappingURL=enums.js.map